import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';

import {FontAwesomeModule, FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {ApiService} from './provider/api-service/api.service';
import {LocalNotifications} from '@ionic-native/local-notifications/ngx';
import {InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';
import {Camera} from '@ionic-native/camera/ngx';
import {ImagePicker} from '@ionic-native/image-picker/ngx';
import {Device} from '@ionic-native/device/ngx';
import {AppVersion} from '@ionic-native/app-version/ngx';
import {SymptoDirectiveModule} from './directives.module';
import {InAppBrowser} from '@ionic-native/in-app-browser/ngx';


@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        FormsModule,
        BrowserModule,
        IonicModule.forRoot({mode: 'ios'}),
        AppRoutingModule,
        FontAwesomeModule,
        HttpClientModule,
        SymptoDirectiveModule],
    providers: [
        StatusBar,
        SplashScreen,
        ApiService,
        LocalNotifications,
        InAppPurchase2,
        Camera,
        ImagePicker,
        Device,
        AppVersion,
        InAppBrowser,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy}
        // use this for export in browser
        // https://medium.com/tinywave/angular-6-404-error-during-refresh-after-deployed-8cec7140b584
        // {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(far, fas, fab);
    }
}
